<template>
	<CampaignLayout :subtitle="trans('tools.campaigns.send.students')" :campaign="campaign">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="send">
				<i class="fa-solid fa-paper-plane mr-2"/>
				{{ trans('general.send') }}
			</PrimaryButton>
		</template>
		<SearchModel attribute="name" :label="trans('account.college_programs.college')" search-type="colleges" no-grow relative @selected="add"/>
		<div class="flex flex-wrap gap-3">
			<div v-for="college in selectedColleges" :key="`college-${college.id}`" class="input-like flex items-center gap-3 flex-nowrap whitespace-nowrap">
				{{ college.name }}
				<CloseButton @close="remove(college)"/>
			</div>
		</div>
	</CampaignLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import {type College} from '@/Types/Settings/College'
import CampaignLayout from '@/Layouts/CampaignLayout.vue'
import SearchModel from '@/Components/Search/SearchModel.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'
import CloseButton from '@/Components/UI/Buttons/CloseButton.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors, showWarning} from '@/Helpers/general'

const props = defineProps<{
	campaign:Campaign,
}>()

const working:Ref<boolean> = ref(false)
const campaign:Ref<Campaign> = ref(props.campaign)
const selectedColleges:Ref<Array<College>> = ref([])

function add(college:College):void{
	const index:number = selectedColleges.value.findIndex((s:College) => s.id === college.id)
	if(index === -1){
		selectedColleges.value.push(college)
	}
}

function remove(college:College):void{
	const index:number = selectedColleges.value.findIndex((s:College) => s.id === college.id)
	if(index > -1){
		selectedColleges.value.splice(index, 1)
	}
}

function send():void{
	if(selectedColleges.value.length === 0){
		showWarning(trans('general.selected.empty'))
	} else if(!working.value){
		working.value = true
		showInfo(trans('tools.campaigns.mails.sending'))
		axios.post(route('tools.campaigns.send.students.store', campaign.value.id), {
			selected: selectedColleges.value,
		}).then(() => {
			showSuccess(trans('tools.campaigns.mails.sent'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>
